import script from "./Firstname.vue?vue&type=script&setup=true&lang=js"
export * from "./Firstname.vue?vue&type=script&setup=true&lang=js"

import "./Firstname.vue?vue&type=style&index=0&id=529eb19e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529eb19e"]])

export default __exports__